import { FC } from 'react'

import clsx from 'clsx'

import { defaultBorder, errorBorder } from 'shared/constants'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { Paper } from '../paper'

import s from './styles.module.scss'

interface Props {
  icon?: AllIcons
  rightIcon?: AllIcons
  value?: string
  placeholder?: string
  onClick?: () => void
  radius?: number
  error?: boolean
  height?: 'auto' | '100%'
  type?: 'white' | 'grey'
  iconPlace?: 'left' | 'right'
  isBlackIcon?: boolean
  isEllipsis?: boolean
  disabled?: boolean
}

export const ButtonIconTextWithLabel: FC<Props> = ({
  icon,
  rightIcon,
  value,
  placeholder,
  error,
  radius,
  onClick,
  type = 'grey',
  height = 'auto',
  iconPlace = 'left',
  isBlackIcon,
  isEllipsis,
  disabled,
}) => {
  return (
    <Paper
      type={type}
      padding={[0, 0]}
      radius={radius || 16}
      height={height}
      border={error ? errorBorder : defaultBorder}
      backgroundColor="#F4F6F7"
      className={s.paper}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={s.container}
      >
        {icon && iconPlace === 'left' ? (
          <AppIcon
            id={icon}
            className={clsx(s.icon, error && s.iconError)}
          />
        ) : null}

        <div className={s.labelContainer}>
          {value && value.length > 0 && (
            <span className={clsx(s.label, 'medium-12')}>{placeholder}</span>
          )}
          <p
            className={clsx(
              {
                [s.value]: !!value?.length,
                [s.isEllipsis]: isEllipsis,
              },
              'medium-16',
            )}
          >
            {value?.length ? value : placeholder}
          </p>
        </div>

        {rightIcon ? (
          <AppIcon
            id={rightIcon}
            className={clsx(
              s.rightIcon,
              error && s.iconError,
              isBlackIcon && s.blackIcon,
            )}
            width={24}
            height={24}
          />
        ) : null}
      </button>
    </Paper>
  )
}
